import { render } from "./AllNotes.vue?vue&type=template&id=3c66c92a"
import script from "./AllNotes.vue?vue&type=script&lang=js"
export * from "./AllNotes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__